export default __webpack_public_path__ + "static/media/no_image.8cd9efd4.jpg";